{
  "checkedInTitle": "You're checked in",
  "postCheckInInstructions": "Post check-in instructions",
  "appointmentDetails": "Appointment details",
  "notifyWarehouse": "We let the warehouse know you arrived so they can check their availability",
  "waitForStaff": "Please wait for further instructions from the warehouse staff",
  "unplannedDescription": "It seems like you don't have an appointment. Please wait for further instructions from the warehouse staff.",
  "whatsappDelay": "The first WhatsApp message may take up to one minute to arrive.",
  "bookNextTitle": "Book an appointment for next time",
  "bookNextBody": "Register to Opendock so you can book an appointment the next time you come to this facility",
  "helpFooter": "If you need any help or additional information, please contact the warehouse staff",
  "finalize": "Finalize ({seconds})"
}
